import React, { Component } from 'react';

import Page from '../page';
import Faq from '../faq';
import SupportCTA from '../supportcta';


export default class extends Component {

    render() {

        return (
            <Page {...this.props}>
                <SupportCTA />
                <Faq />
            </Page>
        );
    }
};
